import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { IDataService } from '../../../../services/data/data-service.interface';
import { OfferPaymentModel, OfferPaymentModelMapped, OfferPaymentModelsParsed } from './interfaces/offer-payout-models.interface';

@Component({
  selector: 'gtd-ui-field-special-offer-payout-models-to-profile',
  templateUrl: './offer-payout-models-to-profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferPayoutModelsToProfileComponent implements OnInit {
  @Input() data: OfferPaymentModel[];
  public mappedData: Array<OfferPaymentModelMapped[]> = [[]];
  public tableHeaders: string[] = [
    $localize`:@@common.goal_types:Goal Types`,
    $localize`:@@common.payout_models:Payout Models`,
    $localize`:@@common.payout:Payout`,
  ];

  constructor(@Inject('IDataService') public dataService: IDataService) {}

  ngOnInit(): void {
    const globalData = this.dataService.getData();

    const parsedData: OfferPaymentModelsParsed[] = [];
    this.data?.forEach((model) => {
      this.parseByGoalType(parsedData, model);
    });

    parsedData.forEach((model) => {
      this.mappedData.push([
        {
          value: globalData.goal_types[model.type] ?? $localize`:@@common.all:All`,
          type: 'string',
          customClass: globalData.goal_types[model.type] ? '' : 'text-color text-color--gray',
        },
        {
          value: globalData.payout_models[model.payout_model_id]?.short_name,
          type: 'string',
        },
        {
          value: model.min_payout === model.max_payout ? `${model.max_payout}` : `${model.min_payout}-${model.max_payout}`,
          type: 'string_justify_end',
        },
      ]);
    });
  }

  private parseByGoalType(array: OfferPaymentModelsParsed[], model: OfferPaymentModel): void {
    if (model.goal_types.length > 1) {
      model.goal_types.forEach((type) => {
        this.addPayoutModel(array, model, type);
      });
    } else {
      const type = model.goal_types[0] ?? null;
      this.addPayoutModel(array, model, type);
    }
  }

  private addPayoutModel(array: OfferPaymentModelsParsed[], model: OfferPaymentModel, type: string): void {
    const existingElement = array.find((el) => el.payout_model_id === model.payout_model_id && el.type === type);
    if (existingElement) {
      existingElement.min_payout = Math.min(existingElement.min_payout, model.payout);
      existingElement.max_payout = Math.max(existingElement.max_payout, model.payout);
    } else {
      array.push({
        type,
        payout_model_id: model.payout_model_id,
        min_payout: model.payout,
        max_payout: model.payout,
      });
    }
  }
}
